exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-progress-spinner {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.message {\n  margin-left: 0.5em;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader?{"sourceMap":true}!./~/resolve-url-loader!./~/sass-loader/lib/loader.js?sourceMap!./src/app/shared/loader/loader.component.scss
// module id = 767
// module chunks = 0